"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginLeft: 6,
            minWidth: 48,
            minHeight: 24,
        },
        statusInfoSpacing: {
            marginRight: 8,
        },
        errorIcon: {
            transform: 'translateY(0.5px)',
            cursor: 'pointer',
        },
        clearIcon: {
            cursor: 'pointer',
        },
    });
});
